import React from 'react';
import { Row, Footer, Filter, Navbar, SearchResultMain, Container } from '../../components';

const SearchResults = () => {
  return (
    <>
      <Navbar sticky isColored/>
      <Container>
      <Row evenly style={{paddingTop:"15px"}}>
        <Filter />
        <SearchResultMain />
      </Row>
      </Container>
      <Footer />
    </>
  );
};

export default SearchResults;
